import { Link, useRouterState } from '@tanstack/react-router';
import { cn } from '@/lib/utils';
import { useI18n } from '@/lib/i18n';

/** The module's two tabs: the live charts, and the research notes. */
export function FibTabs() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const { t } = useI18n();
  const tabs = [
    { to: '/fibonacci', label: t('fib.tabCharts'), active: pathname === '/fibonacci' },
    { to: '/fibonacci/research', label: t('fib.tabResearch'), active: pathname.startsWith('/fibonacci/research') },
  ];
  return (
    <nav className="flex gap-1 rounded-xl bg-elevated p-1 text-sm" aria-label={t('fib.title')}>
      {tabs.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          aria-current={tab.active ? 'page' : undefined}
          className={cn(
            'rounded-lg px-3 py-1.5 font-medium transition-colors',
            tab.active ? 'bg-background text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  );
}
